export const USER_KINDS = {
  CONSUMER: 'CONSUMER',
  LISTING_AGENT: 'LISTING_AGENT',
  PRIVATE_SELLER: 'PRIVATE_SELLER',
}

export const AUTH_INTENT_KINDS = {
  DOWNLOAD_INVENTORY: 'download inventory',
  NONE: '',
}

export const AUTH_TYPES = {
  SIGNUP: 'signup',
  LOGIN: 'login',
}
